if (!customElements.get('appear-animate-single')) {
  class AppearAnimateSingle extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!window.appearAnimate && this.dataset.force == undefined) return;
      Motion.inView(this, (info) => {
        this.showElement()
      });
    }

    showElement() {
      if(!this.dataset.immediate) {
        setTimeout(() => this.classList.add('appear'), 500);
      } else {
        this.classList.add('appear');
      }
    }
  };
  
  customElements.define('appear-animate-single', AppearAnimateSingle);
}

if (!customElements.get('appear-animate-list')) {
  class AppearAnimateList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(!window.appearAnimate) return;
      this.delay = this.dataset.delay ? parseFloat(this.dataset.delay): 0.1;
      this.items = this.querySelectorAll('.appear-animate-item-in-list');

      // 过滤掉产品卡片，只保留标题等元素
      this.itemsToAnimate = Array.from(this.items).filter(item => {
        // 检查是否为产品卡片或产品相关元素
        const isProductCard = item.classList.contains('card--product') ||
                             item.classList.contains('card-wrapper--product') ||
                             item.classList.contains('card-product-special--splash') ||
                             item.closest('.card--product') ||
                             item.closest('.card-wrapper--product') ||
                             item.closest('[class*="card-product"]') ||
                             // 检查是否包含产品相关的子元素
                             item.querySelector('.card--product') ||
                             item.querySelector('.card-wrapper--product');

        return !isProductCard;
      });

      Motion.inView(this, (info) => {
        this.classList.add('start');
        this.showElements();
      });
    }

    showElements() {
      // 只对筛选后的元素应用动画
      if (this.itemsToAnimate.length > 0) {
        Motion.animate(this.itemsToAnimate, { transform: 'translateY(0)', opacity: 1 }, { delay: Motion.stagger(this.delay), duration: 0.5, easing: `cubic-bezier(.03,.93,.97,1)` }).finished.then(() => {
          this.itemsToAnimate.forEach(item => {
            item.classList.add('done');
            item.removeAttribute('style');
          });
        });
      }

      // 直接显示产品卡片，不应用动画
      this.items.forEach(item => {
        if (!this.itemsToAnimate.includes(item)) {
          item.classList.add('done');
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }
      });
    }

    reset() {
      if(!window.appearAnimate) return;
      this.items = this.querySelectorAll('.appear-animate-item-in-list:not(.done)');

      // 重新过滤要动画的元素
      this.itemsToAnimate = Array.from(this.items).filter(item => {
        // 检查是否为产品卡片或产品相关元素
        const isProductCard = item.classList.contains('card--product') ||
                             item.classList.contains('card-wrapper--product') ||
                             item.classList.contains('card-product-special--splash') ||
                             item.closest('.card--product') ||
                             item.closest('.card-wrapper--product') ||
                             item.closest('[class*="card-product"]') ||
                             // 检查是否包含产品相关的子元素
                             item.querySelector('.card--product') ||
                             item.querySelector('.card-wrapper--product');

        return !isProductCard;
      });

      this.showElements();
    }
  };

  customElements.define('appear-animate-list', AppearAnimateList);
}